import axios from 'axios';
import * as types from './actionTypes';
import * as urls from './urlTypes';
import {
  toastError,
} from '../util/toastUtils';

export function pingTest() {
  const url = 'http://sims-mck-integration-3.int.hitwise.com/api/qts/ping';
  return dispatch => {
    axios({
      url,
      method: 'get',
      responseType: 'json',
    })
      .then(response => {
        dispatch({
          type: types.QTS_PING_TEST,
          payload: response.data,
        });
      })
      .catch(response => {
        console.warn(response);
      });
  };
}

export function getQtsSingleSignOnUrl(token, userId, accountId) {
  const url = `${
    urls.QTS_ROOT_URL
  }/getauthencticationurl?accountid=${accountId}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => {
        dispatch({
          type: types.QTS_GET_SURVEYGIZMO_LOGIN_URL,
          payload: response.data.data,
        });
      })
      .catch(response => {
        console.warn(response);
        toastError('Error in fetching Gizmo Single SignOn URL');
      });
  };
}

export function getQtsSurveyList(token, userId, accountId) {
  const url = `${
    urls.QTS_ROOT_URL
  }/getsimmonssurveylist?accountid=${accountId}&userId=${userId}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => {
        dispatch({
          type: types.QTS_GET_SURVEY_LIST,
          payload: response.data,
        });
      })
      .catch(response => {
        console.warn(response);
        toastError('Error in fetching survey List');
      });
  };
}

export function getDictionaryTreeLoad(
  token,
  uid,
  accountId,
  productNo,
  nodeID,
  filter,
) {
  const url = `${urls.ROOT_URL}/dictionary/treeloadex`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      responseType: 'json',
      data: {
        uid,
        accountId,
        productNo,
        node: nodeID,
        filter,
      },
    })
      .then(response =>
        dispatch({
          type: types.GET_QTS_REPORTS_DICTIONARY_TREE_LOAD,
          payload: response.data,
          nodeID,
        }),
      )
      .catch(response => console.warn(response.data));
  };
}

export const setQtsViewType = viewType => ({
  type: types.QTS_VIEW_TYPE,
  payload: viewType,
});

export const setQtsSelectedStudy = study => ({
  type: types.QTS_SELECTED_STUDY,
  payload: study,
});

export const setSurveyGizmoLoggedIn = loginStatus => ({
  type: types.QTS_SURVEY_GIZMO_LOGGEDIN,
  payload: loginStatus,
});

export const clearQtsSurvey = clearSurveyList => ({
  type: types.QTS_CLEAR_SURVEY,
  payload: clearSurveyList,
});

export const updateSampleEdited = status => ({
  type: types.QTS_SURVEY_INFO_SAMPLE_EDITED,
  payload: status,
});

export function getQtsSurveyDictionaryQuestions(token, surveyid) {
  const url = `${urls.QTS_ROOT_URL}/getsurveyquestions?surveyid=${surveyid}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => {
        dispatch({
          type: types.QTS_GET_SURVEY_QUESTIONS,
          payload: response.data,
        });
      })
      .catch(response => {
        toastError(
          `Error in Fetchin Questions from API, error code ${response.status}`,
        );
      });
  };
}

export function getQtsSurveyDictionaryOptions(token, surveyid) {
  const url = `${urls.QTS_ROOT_URL}/getsurveyoptions?surveyid=${surveyid}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => {
        dispatch({
          type: types.QTS_GET_SURVEY_OPTIONS,
          payload: response.data,
        });
      })
      .catch(response => console.warn(response));
  };
}

export function updateQtsDictionaryQuestionOptions(
  token,
  qtsQuestion,
  qtsOptions,
) {
  const url = `${urls.QTS_ROOT_URL}/updateqandosixty`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      data: {
        qTSQuestion: qtsQuestion,
        qTSOption: qtsOptions,
      },
    })
      .then(response =>
        dispatch({
          type: types.UPDATE_QTS_DICTIONARY_QO,
          payload: response.data,
        }),
      )
      .catch(response => console.warn(response.data));
  };
}

export const saveNewSurveyInformation = (
  surveName,
  surveyLength,
  ir,
  sample,
  expression,
  cost,
  categoryExpanded,
  selectedCategories,
  rows,
) => ({
  type: types.QTS_NEW_SURVEY_NAME,
  payload: {
    surveyName: surveName,
    surveyLength,
    ir,
    sample,
    expression,
    cost,
    categoryExpanded,
    selectedCategories,
    rows,
  },
});

export function getQtsTargetingCrieteria(studyTypeId) {
  const url = `${urls.ROOT_URL}/qts/keywords/${studyTypeId}`;
  return dispatch => {
    return axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => {
        dispatch({
          type: types.QTS_TARGETING_CRIETERIA,
          payload: response.data,
        });
        if (response.data) {
          return true;
        }
      })
      .catch(response => {
        console.warn(response);
      });
  };
}

export function getProdigyFeasibilityRun(token, prodigyExpression) {
  const url = `${urls.QTS_ROOT_URL}/prodegefeasibilityrun`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      data: JSON.parse(prodigyExpression),
    })
      .then(response => {
        const payload = {
          data: response.data,
          prodigyExpression,
        };
        dispatch({
          type: types.GET_QTS_FEASIBILITY_RUN,
          payload,
        });
      })
      .catch(response => console.warn(response));
  };
}

export function createSimmonsSurvey(
  token,
  surveyName,
  accountid,
  userid,
  studyCode,
  productNo,
  expression,
  cost,
  targetingCriteria,
  sir,
) {
  const url = `${urls.QTS_ROOT_URL}/createqtssurvey`;
  return dispatch => {
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      data: {
        surveyName,
        accountid,
        userid,
        studyCode,
        productNo,
        expression,
        estimatedCost: cost,
        targetingCriteria,
        incidenceRate: sir,
      },
    })
      .then(response => {
        if (response.status !== 200) {
          toastError('Api failed to create survey');
          return false;
        }
        if (response.data === 0) {
          toastError('Api failed to create survey');
          return false;
        }
        dispatch({
          type: types.QTS_CREATE_SIMMONS_PROJECT,
          payload: response.data,
        });

        return true;
      })
      .catch(response => console.warn(response));
  };
}

export function createProdigyProject(
  token,
  accountid,
  project_name,
  loi,
  sample_size,
  ir,
  gizmoApiToken,
  gizmoApiTokenSecret,
  qtsProdigyProjectId,
) {
  const url = `${
    urls.QTS_ROOT_URL
  }/createprodegeproject?accountid=${accountid}`;
  return (dispatch, getState) => {
    const project_id = getState().qts.qtsSimmonsSurveyId;
    const data = {
      project_name,
      project_id,
      loi,
      sample_size,
      gizmoApiToken,
      gizmoApiTokenSecret,
      cpi: 2,
      project_type_id: 1,
      country_id: 1,
      expectedir: ir,
    };
    if (qtsProdigyProjectId) {
      data.prodege_project_id = qtsProdigyProjectId;
    }
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      data,
    })
      .then(response => {
        if (response.status !== 200) {
          toastError('Api failed to create the project');
          return false;
        }
        if (response.data.data.prodege_project_id === 0) {
          toastError('Api failed to get project id');
          return false;
        }
        dispatch({
          type: types.QTS_CREATE_PRODIGY_PROJECT,
          payload: response.data,
        });

        return response.data.data.prodege_project_id;
      })
      .catch(response => console.warn(response));
  };
}

export function createProdigyQuota(token, sample_size, prodigyExpression) {
  return (dispatch, getState) => {
    const project_id = getState().qts.qtsProdigyProjectId;

    const url = `${
      urls.QTS_ROOT_URL
    }/${project_id}/${sample_size}/createprodegequota`;
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      data: JSON.parse(prodigyExpression),
    })
      .then(response => {
        if (response.status !== 200) {
          if (project_id !== undefined) {
            toastError('Api failed to create project Quota');
          }
          return false;
        }
        if (response.data.quota_id === 0) {
          toastError('Api failed to create project Quota');
        }
        dispatch({
          type: types.QTS_CREATE_PRODIGY_QUOTA,
          payload: response.data,
        });

        return response.data.quota_id;
      })
      .catch(response => console.warn(response));
  };
}

export const getQtsSurvey = surveyId => {
  const url = `${urls.QTS_ROOT_URL}/getqtssurvey?surveyid=${surveyId}`;
  return (dispatch, getState) => {
    return axios({
      url,
      method: 'post',
      withCredentials: true,
      data: {},
    })
      .then(response => {
        const selectedStudy = getState().qts.ieMRIStudies.filter(
          c => c.pn === response.data.data.productNo,
        );
        dispatch({
          type: types.QTS_GET_SURVEY,
          payload: response.data.data,
          study: selectedStudy[0],
        });
        return {
          response: response.data.data.expression,
          selectedStudy: selectedStudy[0],
        };
      })
      .catch(response => {
        console.warn(response);
      });
  };
};

export function saveGizmoQuestions(token, surveyid, expression, gizmoSurveyId) {
  const url = `${urls.QTS_ROOT_URL}/savegizmometadata`;
  return dispatch => {
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      data: {
        gizmoSurveyId,
        expression,
        surveyid,
      },
    })
      .then(response => {
        if (
          response.data.status !== 200 ||
          response.data.message !== null ||
          response.data.data !== 1
        ) {
          toastError('Failed to save survey questions.');
          return false;
        }
        dispatch({
          type: types.SAVE_QTS_GIZMO_QUESTION,
          payload: response.data,
        });
        return true;
      })
      .catch(response => console.warn(response));
  };
}

export function submitForApproval(
  token,
  surveyid,
  accountid,
  userid,
  estimatedCost,
  expression,
  completes,
  incidenceRate,
) {
  const url = `${urls.QTS_ROOT_URL}/submitforapproval`;
  return dispatch => {
    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      data: {
        surveyid,
        accountid,
        userid,
        estimatedCost,
        expression,
        completes,
        incidenceRate,
      },
    })
      .then(response => {
        if (response.status !== 200) {
          toastError('Failed to submit the survey for approval.');
          return false;
        }
        dispatch({
          type: types.QTS_SURVEY_SUBMIT_APPROVAL,
          payload: response.data,
        });
        return true;
      })
      .catch(response => console.warn(response));
  };
}

export function updateSurvey(
  token,
  surveyid,
  surveyName,
  accountid,
  userid,
  studyCode,
  productNo,
  gizmoSurveyId,
  qtsProdigyProjectId,
  expression,
  sample,
  cost,
  targetingCriteria,
  sir,
) {
  const url = `${urls.QTS_ROOT_URL}/updateqtssurvey`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      data: {
        surveyid,
        surveyName,
        accountid,
        userid,
        studyCode,
        productNo,
        gizmoSurveyId,
        prodege_project_id: qtsProdigyProjectId,
        expression,
        requiredCompletes: sample,
        estimatedCost: cost,
        targetingCriteria,
        incidenceRate: sir,
      },
    })
      .then(response =>
        dispatch({
          type: types.UPDATE_QTS_SURVEY,
          payload: response,
        }),
      )
      .catch(response => console.warn(response));
  };
}

export function runIR({
  token,
  uid,
  accountId,
  products,
  weightType,
  rowExpressionList,
  rowHeaderList,
}) {
  const url = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: {
        products,
        weightType,
        baseList: [],
        baseHeaderList: [],
        colExpressionList: [],
        colHeaderList: [],
        rowExpressionList,
        rowHeaderList,
      },
    })
      .then(response =>
        dispatch({
          type: types.QTS_FETCH_IR,
          payload: response.data.data,
          expression: rowExpressionList[0],
          defaultExpression: rowHeaderList[0],
        }),
      )
      .catch(response => console.warn(response));
  };
}


export const createExpressionList = expressionList => {
  return dispatch => {
    dispatch({
      type: types.QTS_EXPRESSION_LIST,
      expression: expressionList,
      defaultExpression: expressionList,
    });
  };
};

export const removeRowSelection = category => {
  return dispatch => {
    dispatch({
      type: types.QTS_REMOVE_ROW_SELECTION,
      category,
    });
  };
};

export const handleStatusClick = surveyid => {
  return dispatch => {
    dispatch({
      type: types.QTS_EDIT_SURVEY,
      surveyid,
    });
  };
};
export const getDefaultSample = () => {
  return dispatch => {
    dispatch({
      type: types.QTS_GET_DEFAULT_SAMPLE,
    });
  };
};

export const resetProdegeProject = () => {
  return dispatch => {
    dispatch({
      type: types.QTS_RESET_PRODEGE_PROJECT,
    });
  };
};

export const setTargetingCriteria = targetingCriteria => {
  return dispatch => {
    dispatch({
      type: types.QTS_SET_TARGETING_CRITERIA,
      targetingCriteria,
    });
  };
};

export const setCurrentSurveyDetails = survey => {
  const url = `${urls.ROOT_URL}/qtsapi/survey/${survey.surveyid}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
    })
      .then(response =>
        dispatch({
          type: types.QTS_SURVEY_DETAIL_HISTORY,
          payload: response.data.data,
        }),
      )
      .catch(response => console.warn(response));
  };
};

export function getIEMRIStudies(uid, accountId) {
  const url = `${urls.ROOT_URL}/users/${uid}/${accountId}/ie-studies`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    })
    .then(response =>
        dispatch({
          type: types.IE_MRI_STUDIES,
          payload: response.data,
        }),
      )
      .catch(response => console.warn(response.data));
  };
}

export const getProdegeMapping = studyTypeId => async dispatch => {
  const url = `${urls.QTS_ROOT_URL}/keywordsprodegemapping/${studyTypeId}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });

    const responseType = typeof (response.data);
    if (response.data && responseType === 'object') {
      // return response.data;
      dispatch({
        type: types.QTS_PRODIGGY_MAPPING,
        payload: response.data,
        studyTypeId,
      });
      return true;
    }
    return false;
  } catch (error) {
    toastError('Keywords progege mapping api fails');
    console.warn(`Keywords progege mapping api fails: ${error}`);
    return false;
  }
};

export const getQtsSurveySuccess = () => dispatch => {
  dispatch({
    type: types.QTS_GET_SURVEY_SUCCESS,
  });
};


export const createQtsProject = payload => async dispatch => {
  const url = `${urls.QTS_ROOT_URL}/createqtsproject`;
  try {
    const response = await axios({
      url,
      method: 'post',
      withCredentials: true,
      responseType: 'json',
      data: payload,
    });
    if (response.data) {
      const responseData = response.data.data;
      if (responseData.qTSProdegeProject.prodege_project_id && responseData.gizmoSurveyId) {
        dispatch({
          type: types.QTS_CREATE_SIMMONS_PROJECT,
          surveyid: responseData.surveyid,
        });
        dispatch({
          type: types.QTS_CREATE_PRODIGY_PROJECT,
          payload: responseData.qTSProdegeProject,
          gizmoSurveyId: responseData.gizmoSurveyId,
        });
        dispatch({
          type: types.QTS_CREATE_PRODIGY_QUOTA,
          payload: responseData,
        });
        return true;
      }
      toastError('Create QTS Project api fails');
      return false;
    }
    return false;
  } catch (error) {
    toastError('Create QTS Project api fails');
    return false;
  }
};

export const updateQtsProject = payload => async dispatch => {
  const url = `${urls.QTS_ROOT_URL}/updateqtsproject`;
  try {
    const response = await axios({
      url,
      method: 'post',
      withCredentials: true,
      responseType: 'json',
      data: payload,
    });
    if (response.data) {
      const responseData = response.data.data;
      if (responseData.qTSProdegeProject.prodege_project_id && responseData.gizmoSurveyId) {
        dispatch({
          type: types.UPDATE_QTS_SURVEY,
          payload: responseData,
        });
        dispatch({
          type: types.QTS_CREATE_PRODIGY_PROJECT,
          payload: responseData.qTSProdegeProject,
          gizmoSurveyId: responseData.gizmoSurveyId,
        });
        dispatch({
          type: types.QTS_CREATE_PRODIGY_QUOTA,
          payload: responseData,
        });
        return true;
      }
      toastError('Update QTS Project api fails');
      return false;
    }
    return false;
  } catch (error) {
    toastError('Update QTS Project api fails');
    return false;
  }
};

export const resetSelectedKeywords = () => dispatch => {
  dispatch({
    type: types.RESET_SELECTED_KEYWORDS,
  });
};
